// extracted by mini-css-extract-plugin
export default {"base":"Covid19Map_base__l7ilF","header":"Covid19Map_header__-Ia8D","content":"Covid19Map_content__ML6U6","body":"Covid19Map_body__Vp6Q6"};